<h2 mat-dialog-title>{{ isBulk ? 'Confirmar Pagamentos em Lote' : 'Efetuar Pagamento' }}</h2>

<mat-dialog-content>
  <div class="modal-overlay" *ngIf="loading">
    <div class="overlay-content">
      <mat-progress-spinner
        diameter="48"
        strokeWidth="4"
        mode="indeterminate"
        class="modal-overlay-spinner"
      ></mat-progress-spinner>
      <p *ngIf="isBulk" class="overlay-hint">
        Processando vários pagamentos. Isto pode levar até alguns minutos, por favor aguarde.
      </p>
    </div>
  </div>

  <ng-container *ngIf="!isBulk; else bulkContent">
    <section class="readonly">
      <div><strong>Profissional:</strong> {{ data.doctorName || '-' }}</div>
      <div><strong>Especialidade:</strong> {{ data.specialtyName || '-' }}</div>
      <div><strong>Valor:</strong> {{ formattedAmount }}</div>
      <div><strong>ID Indicação:</strong> {{ data.indicationId }}</div>
    </section>

    <p class="confirmation-text">
      Tem certeza que deseja efetuar este pagamento?
    </p>
  </ng-container>

  <ng-template #bulkContent>
    <section class="readonly bulk">
      <div><strong>Total de indicações:</strong> {{ data.bulk?.totalCount || 0 }}</div>
      <div><strong>Valor total:</strong> {{ formattedBulkAmount }}</div>
    </section>

    <p class="confirmation-text">
      Deseja efetuar o pagamento para estas indicações? Após confirmar, os valores serão repassados para os respectivos médicos.
    </p>
  </ng-template>

  <div class="actions">
    <button mat-stroked-button type="button" class="cancel" (click)="close()">
      Cancelar
    </button>
    <button mat-stroked-button type="button" class="save" (click)="confirm()" [disabled]="loading">
      <ng-container *ngIf="!loading; else saving">
        Confirmar
      </ng-container>
      <ng-template #saving>
        <mat-progress-spinner
          diameter="20"
          strokeWidth="3"
          mode="indeterminate"
          class="modal-spinner"
        ></mat-progress-spinner>
      </ng-template>
    </button>
  </div>
</mat-dialog-content>
